import { apiService } from './api';
import { MenuItemModifierDTO, CreateMenuItemModifierDTO } from '../types';

const API = '/menu-modifiers';

export const menuModifierService = {
  getByMenuItem: (menuItemId: number) =>
    apiService.get<{ data: MenuItemModifierDTO[] }>(API, { menuItemId }),

  getById: (id: number) =>
    apiService.get<MenuItemModifierDTO>(`${API}/${id}`),

  create: (data: CreateMenuItemModifierDTO) =>
    apiService.post<MenuItemModifierDTO>(API, data),

  update: (id: number, data: Partial<CreateMenuItemModifierDTO>) =>
    apiService.put<MenuItemModifierDTO>(`${API}/${id}`, data),

  delete: (id: number) =>
    apiService.delete<boolean>(`${API}/${id}`),
};
